<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div id="groupBooking">
    <!-- <div id="header">
        <div class="left" @click="onBack()"><img src="../../image/group_booking/back.png"></div>
        <div class="center">拼团详情</div>
        <div class="right" @click="shareType = !shareType"><img src="../../image/group_booking/share.png"></div>
    </div> -->
    <div class="common-hight"></div>
    <!-- <div class="common-warp mescroll" ref="mescroll" id="mescroll" > -->
        <div class="groupDetailInfo">
            <div class="top" v-if="orderGoods">
                <div class="img">
                    <img :src="orderGoods.thumb">
                </div>
                <div class="desc">
                    <h3 class="text-overflow_2-xzh">{{orderGoods.goodsName}}</h3>
                    <div class="price">
                        <span>¥{{orderGoods.goodsPrice}}</span>
                        <p>单人购买: <del>¥{{goodsInfo.spe_price}}</del></p>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="avatar">
                    <span class="colonel" v-for="(item, index) in collageList" :key="index">
                        <img :src="item.userInfo.avatar" alt="">
                        <i v-if="index == 0">{{info.collageTitle}}</i>
                    </span>    
                    <span class="colonel" v-for="x in info.limitNum">
                        <img src="../assets/pintuan/kavatar.png">
                    </span>
                </div>
                <div class="people" v-if="collageInfo.status == 1">   
                    <p class="num">还差<span>{{info.limitNum}}</span>人拼团成功，剩余时间</p>
                    <div class="time">
                        <span><i>{{firstH}}</i><i>{{secondH}}</i></span>:<span><i>{{firstM}}</i><i>{{secondM}}</i></span>:<span><i>{{firstS}}</i><i>{{secondS}}</i></span>
                    </div>
                </div>
                <div class="success" v-else-if="collageInfo.status == 2">拼团成功</div>
                <div class="success" v-else-if="collageInfo.status == 9">拼团失败</div>
                <div class="shareBtn" @click="toAccredit()">
                    <button v-if="collageInfo.status == 1">去参团</button>
                    <button v-else-if="collageInfo.status == 2">查看订单详情</button>
                    <button v-else-if="collageInfo.status == 9">查看更多拼团活动</button>
                </div>
                <div class="rule">支付开团-支付参团-凑齐人数发货-凑不齐退款</div>
            </div>
        </div>
        <div class="group-more common-title goods-list">
            <h3 class="group-detail-title">查看其他拼团商品</h3>
            <div class="list">
                <ul>
                    <li class="flex" v-for="(item, index) in goodsList" :key="index">
                        <div class="left"><img :src="item.thumb" alt=""></div>
                        <div class="right flex_1">
                            <h3 class="title text-overflow_1-xzh">{{item.goodsName}}</h3>
                            <div class="num"><span class="postage">{{item.freeShippingInfo}}</span><span class="piece">已拼{{item.sales}}件</span></div>
                            <div class="btm">
                                <div class="price">
                                    <p><span>{{item.collageNum}}人拼团</span><b>¥{{item.collagePrice}}</b></p>
                                    <span class="single">单人价¥{{item.spe_price}}</span>
                                </div>
                                <button @click="toAccredit()">去拼团</button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    <!-- </div> -->
    <!-- 拼团过期 -->
    <div class="group-time-end">
        <mt-popup
        v-model="groupEnd"
        position="center">
            <div class="groupEnd">
                <div class="logo">
                    <img :src="avatar">
                </div>
                <p class="later"><span>“</span>你来晚了~我的拼团已结束<span>”</span></p>
                <h3 class="tit">挑选心仪的商品重新发起拼团吧</h3>
                <button class="btn" @click="toAccredit()">去逛逛</button>
            </div>
            <div class="groupEndcloseBtn"><img src="../assets/pintuan/guanbi.png" @click="groupEnd = !groupEnd"></div>
        </mt-popup>
    </div>
    <!-- 分享弹窗 -->
     <div class="wechat-pop">
        <mt-popup
            v-model="wechatPop"
            position="top">
            <img src="../assets/pintuan/wechatBrowser.png" alt="">
        </mt-popup>
    </div>
   
</div>
</template>

<script>
import { Toast, Popup } from 'mint-ui'
import axios from 'axios'
import qs from 'qs'
// Vue.component(Popup.name, Popup)
export default {
  name: 'activityCollage',
  data () {
    return {
      codes: false,
      datas: {},
      info: '',
      orderGoods: '',
      goodsInfo: '',
      collageList:'',
      collageInfo: '',
      goodsList:'',
      groupEnd: false,
      time:{D: '', h: '', m: '', s: ''},
      firstH: '0',
      secondH: '0',
      firstM: '0',
      secondM: '0',
      firstS: '0',
      secondS: '0',
      code: '',
      wechatInfo: '',
      oauthUrl: '',
      bizId: '',
      avatar: '',
      wechatPop: false,
      device:'',
      orderId: '',
      shareInfo: '',
      codeVersion: ''
    }
  },
  created () {
      axios.defaults.headers = {
        'Content-type': 'application/x-www-form-urlencoded'
        }
        axios.defaults.transformRequest = (data) => {
        data = qs.stringify(data)
        return data
        }
      this.code = this.GLOBAL.getQueryString('code')
      this.codeInfo = this.GLOBAL.getQueryString('codeInfo')
      this.orderId = this.GLOBAL.getQueryString('orderId')
      this.codeVersion = this.GLOBAL.getQueryString('codeVersion')
      this.device = this.deviceType()
  },
  methods: {
    getInfo(bizId){
          axios.post(this.GLOBAL.apiUrlNative + '/api/' + bizId +'/mall/activity/collage-order-detail',{orderId: this.orderId}).then((res) => {

            if (res.data.code === 0) {
                this.info = res.data.data
                this.orderGoods = res.data.data.orderGoods
                this.goodsInfo = res.data.data.goodsInfo
                this.collageList = res.data.data.collageList
                this.avatar = res.data.data.collageList[0].userInfo.avatar
                this.collageInfo = res.data.data.collageInfo
                if(this.collageInfo.limittime == 0){
                    this.groupEnd = true
                }
                this.$nextTick(() => {
                    this.setEndTime(this.collageInfo.limittime)
                })
            }
        })
    },
    getList(bizId){
        axios.get(this.GLOBAL.apiUrlNative + '/api/' + bizId +'/mall/activity/collage-goods-list').then((res) => {
            if (res.data.code === 0) {
                this.goodsList = res.data.data.list 
            }
        })
    },
     setEndTime(limittime){
        var that = this;
        var interval = setInterval(function timestampToTime(){
            var date = limittime--; //计算剩余的秒数
            if(date <= 0){
                that.isEnd = true;
                clearInterval(interval)
            }else{
                that.time.D = parseInt(date / 60 / 60 / 24 , 10);
                that.time.h = parseInt(date / 60 / 60 % 24 , 10);
                if(that.time.D < 10){
                    that.time.D = "0" +　that.time.D
                }
                if(that.time.h < 10){
                    that.time.h = "0" +　that.time.h
                }
                that.time.m = parseInt(date / 60 % 60, 10);//计算剩余的分钟
                if(that.time.m < 10){
                    that.time.m = "0" +　that.time.m
                } 
                that.time.s = parseInt(date % 60, 10);//计算剩余的秒数 
                if(that.time.s < 10){
                    that.time.s = "0" +　that.time.s
                }

                that.firstD =  that.time.D.slice(0,1)
                that.secondD =  that.time.D.slice(1,2)
                that.firstH =  String(that.time.h).slice(0,1)
                that.secondH =  String(that.time.h).slice(1,2) 
                that.firstM =  String(that.time.m).slice(0,1)
                that.secondM =  String(that.time.m).slice(1,2)
                that.firstS =  String(that.time.s).slice(0,1)
                that.secondS =  String(that.time.s).slice(1,2)
            }
        },1000);
    },
    getDown(){
        // let code = 'MTIwXzk5NzA3'
        axios.get(this.GLOBAL.apiUrlNative + '/api/w1/share/download?code=' + this.code).then((res) => {
            if (res.data.code === 0) {
                this.datas = res.data.data
                this.bizId = res.data.data.bizId
                this.oauthUrl = res.data.data.oauthUrl
                this.shareInfo = res.data.data.shareInfo
                document.title = res.data.data.title
                this.getInfo(this.datas.bizId)
                this.getList(this.datas.bizId)
                if(this.codeInfo){
                    this.inintWechat(this.datas.bizId)
                }
            }
        })
    },
    inintWechat(bizId){
        axios.post(this.GLOBAL.apiUrlNative + '/api/' + bizId +'/amoy/auth/we-login',{type: 'mp', code: this.codeInfo}).then((res) => {    
            if(res.data.code == 0){
                this.wechatInfo = res.data.data
                this.$router.push({
                    path: '/download',
                    query: {code: this.code, codeVersion: this.codeVersion}
                })
            }
        })
    },
    deviceType () {
        let u = navigator.userAgent
        // android终端
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
        // ios终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
            return 'ios'
        } else if (isAndroid) {
            return 'android'
        } else {
            return 'other'
        }
    },
    // 去授权
    toAccredit(){
        console.log('codeInfo', this.codeInfo)
        if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
            
            if(this.codeInfo == null){
              window.location.href = this.oauthUrl + '/api/' + this.bizId + '/wechat/auth/login?activityUrl=' + encodeURIComponent(window.location.href)
            }else{
                // 引导图显示
                // this.wechatPop = true
                this.$router.push({
                    path: '/download',
                    query: {code: this.code, codeVersion: this.codeVersion}
                })
            }
        }else{
             this.$router.push({
                    path: '/download',
                    query: {code: this.code, codeVersion: this.codeVersion}
                })
            // 唤醒app
        //     if(this.device === 'ios'){
        //          window.location.href = this.shareInfo.APP_DOWNLOAD_BAO_IOS
        //     }else{
        //         window.location.href = 'app://' + this.shareInfo.APP_DOWNLOAD_BAO_ANDROID
        //     }
            
        //      let href = ''
        //      if(this.datas.download_type == 'two-in-one'){
        //         href = this.datas.two_in_one
        //      }else{
        //         if(this.device === 'ios'){
        //             href = this.datas.ios
        //         }else{
        //             href = this.datas.android
        //         }
        //      }
        //    let clickedAt = +new Date();
        //     setTimeout(function () {
        //         // webkitHidden检测页面对于用户的可见性(切换标签或者切换后台就不可见了)
        //         !window.document.webkitHidden && setTimeout(function () {
        //             if (+new Date() - clickedAt < 2000) {
        //                 window.location = href;
        //             }
        //         }, 500);
        //     }, 500)
        }
    }
  },
  mounted () {
      this.getDown()
  }
}
</script>
<style>
  
</style>

<style scoped>
    *{
        margin: 0;
        padding: 0
    }
    .flex {
        display: -webkit-box;
        display: box;
    }
    .flex_1 {
        -webkit-box-flex: 1.0;
        box-flex: 1.0;
    }
    button{
        border: none;
        outline: none;
    }
   .groupDetailInfo{
            background-color:#fff;
            margin:.3rem;
            box-shadow:0px 0px 30px 0px rgba(140,140,140,0.25);
            border-radius:5px;
            padding:.28rem .22rem;
        }
        .groupDetailInfo .top{
            display:flex;
            background-color:#F7F7F7;
            padding:.16rem
        }
        .groupDetailInfo .top .img{
            display: flex;
            align-items: center;
            margin-right:.15rem
        }
        .groupDetailInfo .top .img img{
            width:2.18rem;
            height:2.18rem;
            border-radius:5px;
        }
        .groupDetailInfo .top .desc{
            padding:.15rem 0;
            position:relative;
            width: 100%;
        }
        .groupDetailInfo .top .desc h3{
            font-size:.3rem;
            color:#333;
            font-weight:normal;
            overflow: hidden;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .groupDetailInfo .top .desc .price{
            position:absolute;
            bottom:0
        }
        .groupDetailInfo .top .desc .price span{
            font-size:.34rem;
            color:#D92B24;
            font-weight:bold;
            margin-bottom:.15rem
        }
        .groupDetailInfo .top .desc .price p{
            font-size:.24rem;
            color:#999
        }
        .groupDetailInfo .bottom{
            text-align:center;
            margin:.4rem 0 .2rem
        }
        .groupDetailInfo .bottom .avatar img{
            width:1.04rem;
            height:1.04rem;
            border-radius:50%
        }
        .groupDetailInfo .bottom .avatar .colonel{
            display: inline-block;
            position:relative;
            overflow: hidden;
            width: 1.04rem;
            height: 1.04rem;
            border-radius: 50%;
            margin: 0 .2rem;
            font-size: 0
        }
        .groupDetailInfo .bottom .avatar .colonel i{
            font-style:normal;
            position:absolute;
            bottom: 0px;
            left: 0px;
            right:0;
            display:inline-block;
            height: .3rem;
            line-height: .3rem;
            font-size: .2rem;
            background-color:#000;
            opacity:0.5;
            color: #fff;
        }
        .groupDetailInfo .people .num{
            font-size:.28rem;
            margin:.3rem 0 .2rem
        }
        .groupDetailInfo .people .num span{
            font-size:.3rem;
            color:#D92B24;
            
        }
        .groupDetailInfo .people .time{
            font-size:.36rem;
            line-height: .54rem;
            display: flex;
            justify-content: center;
        }
        .groupDetailInfo .people .time span{
            margin:0 .08rem
        }
        .groupDetailInfo .people .time span i{
            font-style:normal;
            display:inline-block;
            width:.34rem;
            height:.54rem;
            line-height:.54rem;
            background-color:#5B5B5B;
            border-radius:2px;
            font-size:.30rem;
            color:#fff;
            margin: 0 .04rem
        }
        .groupDetailInfo .bottom .avatar{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .groupDetailInfo .bottom .success{
            font-size: .32rem;
            color: #2f2f2f;
            margin-top: .35rem;
        }
        .groupDetailInfo .shareBtn {
            margin:.36rem 0 .34rem;
            display: flex;
            justify-content: center;
        }
        .groupDetailInfo .shareBtn button{
            min-width:3.26rem;
            height:.78rem;
            line-height:.78rem;
            font-size:.32rem;
            background:linear-gradient(-90deg,rgba(217,33,33,1) 0%,rgba(248,123,100,1) 99%);
            border-radius:39px;
            color:#fff;
            padding: 0 .9rem;
            border: none;
            outline: none
        }
        .groupDetailInfo .rule{
            font-size:.24rem;
            color:#999
        }
        /* 更多拼团 */
        .group-more {
            margin-top: .21rem;
            background: #fff;
        }
        .group-detail-title {
            height: .9rem;
            line-height: .9rem;
            font-size: .28rem;
            color: #2f2f2f;
            text-align: center;
            font-weight: normal;
        }
        .goods-list .list li{
            padding: .24rem .3rem;
            border-top: 1px solid #EEEEEE;
        }
        .goods-list .list li .left{
            display: flex;
            align-items: center
        }
        .goods-list .list li .left img{
            width: 2.3rem;
            height:2.3rem;
            border-radius:.05rem;
            margin-right:.2rem
        }
        .goods-list .list li .right{
            width: 4.4rem;
        }
        .goods-list .list li .right .title{
            font-size:.28rem;
            color:#333333;
            font-weight:normal;
            line-height: .45rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .goods-list .list li .right .num {
            height:.32rem;
            line-height:.32rem;
            font-size:.22rem;
            margin:.20rem 0 .38rem
        }
        .goods-list .list li .right .num .postage{
            padding: 0 .12rem;
            background:rgba(255,233,233,1);
            border-radius:16px;
            color:#FF1D1C;
            margin-right:.1rem
        }
        .goods-list .list li .right .num .piece{
            color:#666;
            border:1px #999 solid;
            border-radius:.16rem;
            padding: 0 .1rem
        }
        .goods-list .list li .right .btm{
            display:flex;
            align-items:center;
            justify-content: space-between;
        }
        .goods-list .list li .right .btm .price{
            display: flex;
            flex-direction: column;
        }
        .goods-list .list li .right .btm .price p{
            font-size:.34rem;
            color:#D92B24;
            margin-bottom: .06rem;
        }
        .goods-list .list li .right .btm .price p span{
            font-size:.26rem;
            margin-right: .2rem
        }
        .goods-list .list li .right .btm .price .single{
            font-size: .24rem;
            color: #999;
        }
        .goods-list .list li .right .btm  button{
            height: .56rem;
            line-height: .56rem;
            color: #fff;
            font-size: .28rem;
            background:linear-gradient(-90deg,rgba(217,33,33,1) 0%,rgba(248,123,100,1) 99%);
            border-radius:.28rem;
            padding: 0 .3rem;
        }
        /* 过期弹窗 */
       .group-time-end .mint-popup{
            border-radius:.15rem
        }
        .groupEnd{
            text-align:center;
            width: 5.6rem;
        }
        .groupEnd .logo{
            width:1.4rem;
            height:1.4rem;
            margin:-.75rem auto;
            background-color:#fff;
            padding:.1rem;
            border-radius:50%

        }
        .groupEnd .logo img{
        /* 	width:100%; */
            width:1.4rem;
            height:1.4rem;
            border-radius:50%
        }
        .groupEnd .later{
            margin-top:1rem;
            font-size:.28rem;
            color:#2F2F2F
        }
        .groupEnd .later span{
            font-size:.4rem;
            color:#CFCFCF
        }
        .groupEnd  .tit{
            font-size:.3rem;
            color:#2F2F2F;
            margin:.3rem 0 .5rem
        }
        .groupEnd .btn{
            width:3.8rem;
            height:.8rem;
            background:linear-gradient(270deg,rgba(217,33,33,1),rgba(248,123,100,1));
            border-radius:40px;
            font-size:.3rem;
            color:#fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto .38rem;
        }
        .groupEndcloseBtn {
            position: absolute;
            width: 5.6rem;
            text-align: center;
            margin-top: .9rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .groupEndcloseBtn img {
            width: .7rem;
        }
        .wechat-pop .mint-popup-top{
            background: transparent;
            width: 100%;
            text-align: right;
            padding: .3rem
        }
        .wechat-pop .mint-popup-top img{
            width: 80%;
            margin-right: .3rem
        }
</style>



// WEBPACK FOOTER //
// src/components/activityCollage.vue